// @flow strict
import React from "react";
import styles from "./Header.module.css";

type Props = {
  exit?: React$Node,
  children?: React$Node,
};

export function Header(props: Props): React$Node {
  return (
    <header className={styles.header}>
      <span className={styles.headerTitle}>
        <a href="https://el-gato-encerrado.com">El Gato Encerrado</a>
      </span>
      {props.exit}
      <nav id="nav">
        <ul>
          <li className="special">
            <a
              target="_blank"
              href="https://wa.me/34665478730?text=Buenas%2c%20me%20gustar%C3%ADa%20hacer%20una%20reserva%20para%20una%20de%20vuestras%20escape%20rooms"
              className="icon icon-b fa-whatsapp"
              rel="noopener noreferrer"
            >
              ¡Escríbenos!
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
